"use client";

import { useEffect, useState } from "react";
import { MemberScore } from "types/api";
import { getMemberPlacement } from "util/api-requests";
import { useAccount } from "wagmi";

export const useMemberPlacement = (contestId: number) => {
  const [list, setList] = useState<MemberScore>();
  const { address } = useAccount();
  useEffect(() => {
    (async () => {
      if (address) {
        const score = await getMemberPlacement(address, contestId);
        if (!score[0]) return;
        setList(score[0]);
      }
    })();
  }, [address, contestId]);

  return list;
};
